module.exports = __webpack_public_path__ + "img/林霏开.499324f1.jpg";